


















import { Component, Vue } from "vue-property-decorator";

import { VerifySubjectViewModel } from "@/citizen/vms/VerifySubjectViewModel";
import { VerifySubjectController } from "@/citizen/controllers/VerifySubjectController";
import { VerifySubjectPresenter } from "@/citizen/presenters/VerifySubjectPresenter";
import { EmailManager } from "../interactor/EmailManager";
import { EmailManagerRestGateway } from "@/gateways/rest/EmailManagerRestGateway";
import { AxiosRestConnection } from "@/gateways/rest/connection/AxiosRestConnection";
import { AxiosLogger } from "@/logging/AxiosLogger";
import { ConsoleLogger } from "@/logging/ConsoleLogger";
import { I18NextTranslator } from "../../plugins/i18n/I18NextTranslator";

@Component({
  components: {
    Title: () => import("@/components/layout/Title.vue"),
    Paragraph: () => import("@/components/layout/Paragraph.vue"),
    Progress: () => import("@/components/basic/Progress.vue")
  }
})
export default class VerifySubject extends Vue {
  private vm = new VerifySubjectViewModel();
  private controller: any;

  private created() {
    this.controller = this.createController();
  }

  private createController() {
    return new VerifySubjectController(
      new VerifySubjectPresenter(this.vm, new I18NextTranslator()),
      new EmailManager(
        new EmailManagerRestGateway(
          new AxiosRestConnection(
            process.env.VUE_APP_BACKEND_URL,
            new AxiosLogger(new ConsoleLogger())
          )
        )
      )
    );
  }

  private get subject() {
    return this.$route.params.subject;
  }

  private get token() {
    return this.$route.params.token;
  }

  private get mode() {
    return this.$route.params.mode;
  }

  private mounted() {
    this.controller.init(this.subject, this.mode, this.token);
  }
}
